import { BffEndpoints } from '@/requests';
import {
  CPDDeliveryMethodOptions,
  CPDProviderOptions,
  CustomCertificateInput,
} from '@/types';

import { bffApi } from '../bff-api';
import { postgrestApi } from '../postgrest-api';
import { PostgrestApiTags } from '../store.constants';

export const trackerBffApiSlice = bffApi.injectEndpoints({
  endpoints: builder => ({
    createCustomCertificate: builder.mutation<null, FormData>({
      query: certificate => ({
        url: BffEndpoints.CUSTOM_CERTIFICATE,
        method: 'POST',
        body: certificate,
        formData: true,
      }),
      onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
        try {
          await queryFulfilled;
          dispatch(
            postgrestApi.util.invalidateTags([
              PostgrestApiTags.PD_HOURS,
              PostgrestApiTags.TRIENNIAL_SUMMARY,
            ]),
          );
        } catch {
          // no need to do anything, the error will be handled in the component
        }
      },
    }),
    updateCustomCertificate: builder.mutation<
      null,
      {
        certificateId: number;
        certificateData: CustomCertificateInput;
      }
    >({
      query: ({ certificateId, certificateData }) => ({
        url: `${BffEndpoints.CUSTOM_CERTIFICATE}`,
        method: 'PUT',
        body: {
          certificateId,
          certificateData: {
            title: certificateData.title,
            description: certificateData.description,
            isNasba: false,
            hoursOrCredit: certificateData.credit,
            ethicHours: certificateData.isEthics
              ? certificateData.credit
              : undefined,
            dateCompleted: certificateData.dateCompleted,
            deliveryMethod:
              certificateData.deliveryMethod === CPDDeliveryMethodOptions[0]
                ? undefined
                : certificateData.deliveryMethod,
            provider:
              certificateData.provider === 'Other'
                ? certificateData.otherProvider
                : certificateData.provider === CPDProviderOptions[0]
                  ? undefined
                  : certificateData.provider,
            ...(certificateData.complianceType === 'CPE' && {
              location: certificateData.location,
              fieldOfStudy: certificateData.fieldOfStudy[0].fieldOfStudyId,
            }),
          },
        },
      }),
      onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
        try {
          await queryFulfilled;
          dispatch(
            postgrestApi.util.invalidateTags([
              PostgrestApiTags.PD_HOURS,
              PostgrestApiTags.TRIENNIAL_SUMMARY,
            ]),
          );
        } catch {
          // no need to do anything, the error will be handled in the component
        }
      },
    }),
    deleteCustomCertificate: builder.mutation<null, { certificateId: number }>({
      query: ({ certificateId }) => ({
        url: `${BffEndpoints.CUSTOM_CERTIFICATE}`,
        method: 'DELETE',
        body: { certificateId },
      }),
      onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
        try {
          await queryFulfilled;
          dispatch(
            postgrestApi.util.invalidateTags([
              PostgrestApiTags.PD_HOURS,
              PostgrestApiTags.TRIENNIAL_SUMMARY,
            ]),
          );
        } catch {
          // no need to do anything, the error will be handled in the component
        }
      },
    }),
  }),
});

export const {
  useCreateCustomCertificateMutation,
  useUpdateCustomCertificateMutation,
  useDeleteCustomCertificateMutation,
} = trackerBffApiSlice;
